<table class="table">
  <thead>
    <th>Name</th>
    <th>Email</th>
    <th></th>
  </thead>
  <tbody>
    <tr *ngFor="let teacher of class.Teachers" [class.hover]="deleteObj !== teacher"
      (click)="goToRoute(teacher, '/accounts/' + teacher.AccountID)">
      <td>
        <a [routerLink]="'/accounts/' + teacher.AccountID">
          <app-profile-picture class="mr-2" [name]="teacher.Name"></app-profile-picture>
          {{ teacher.Name }}
        </a>
      </td>
      <td>{{ teacher.Email}}</td>
      <td class="text-center icon">
        <span (click)="deleteTeacher($event, teacher)" *ngIf="deleteObj !== teacher" ngbTooltip="Delete">
          <i class="fal fa-trash-alt pointer"></i>
        </span>
        <span *ngIf="deleteObj === teacher">
          <i class="fal fa-spinner fa-spin"></i>
        </span>
      </td>
    </tr>
  </tbody>
</table>
